import {QueryClient} from "@tanstack/react-query";

import {throwOnErrorHandler} from "@/src/modules/core/lib/tanstack-error";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: false,
      throwOnError: throwOnErrorHandler,
    },
    mutations: {
      retry: false,
      throwOnError: throwOnErrorHandler,
    },
  },
});
